import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CampaignDevTools } from "../components/CampaignDevTools"
import { useAuth } from "../hooks/useAuth";
import { Campaign } from "../interfaces/Campaign.interface";
import { Flex, Typography } from "antd";

export const DevTools = (props: { applicationId:string, apiKey:string})=>{

    const auth = useAuth();
    // Mutations
    const queryClient = useQueryClient();
    const campaignMutation = useMutation({
        mutationFn: (campaign: Campaign) => auth.api.createCampaign(props.applicationId, campaign),
        onSuccess: () => {
            // Invalidate and refetch
            queryClient.invalidateQueries({ queryKey: ['campaigns', props.applicationId] })
        },
    })
    
    const onCampaignSave = async (campaign: Campaign): Promise<boolean> => {
            let result = false;
            let newCampaign = await campaignMutation.mutateAsync(campaign);
            

            return result;
        }


    return (
        <Flex vertical gap={10}>
            <Flex justify="space-between"><Typography.Title level={3}>Push DevTools</Typography.Title></Flex>
            <CampaignDevTools applicationId={props.applicationId} apiKey={props.apiKey} onSaveCampaign={onCampaignSave}/>
        </Flex>
    )
}